// Metadata pexesa sdílená serverem i klientem (názvy, obrázky, zvuky). Žádná logika.

export interface Animal {
  id: string;
  /** Jak se karta hlásí čtečce. */
  name: string;
  /** Soubor obrázku v public/img/pexeso/. */
  image: string;
  /** Pastelové pozadí líce karty: zvýší kontrast obrázku a pomůže rozlišit podobná zvířata. */
  color: string;
}

// Pořadí je důležité: malá hra bere prvních 6 (nejznámější zvuky).
export const ANIMALS: Animal[] = [
  { id: "pes", name: "pes", image: "dog.png", color: "#ffe08a" },
  { id: "krava", name: "kráva", image: "cow.png", color: "#c8f0c0" },
  { id: "prase", name: "prase", image: "pig.png", color: "#c9e7ff" },
  { id: "kachna", name: "kachna", image: "duck.png", color: "#ffd3b0" },
  { id: "kun", name: "kůň", image: "horse.png", color: "#bfe9f2" },
  { id: "slepice", name: "slepice", image: "chicken.png", color: "#ffc9c9" },
  { id: "zaba", name: "žába", image: "frog.png", color: "#ffe6f2" },
  { id: "slon", name: "slon", image: "elephant.png", color: "#ffd88a" },
  { id: "sova", name: "sova", image: "owl.png", color: "#d6d0ff" },
  { id: "opice", name: "opice", image: "monkey.png", color: "#c7f5d6" },
  { id: "koza", name: "koza", image: "goat.png", color: "#ffcfe8" },
  { id: "had", name: "had", image: "snake.png", color: "#fff1a8" },
];

export const ANIMAL_BY_ID: Record<string, Animal> = Object.fromEntries(ANIMALS.map((a) => [a.id, a]));

export const SIZES: Record<string, { rows: number; cols: number; label: string }> = {
  mala: { rows: 3, cols: 4, label: "Malá: 3 řádky, 4 sloupce, 6 párů" },
  stredni: { rows: 4, cols: 4, label: "Střední: 4 řádky, 4 sloupce, 8 párů" },
  velka: { rows: 4, cols: 6, label: "Velká: 4 řádky, 6 sloupců, 12 párů" },
};

/** Jak dlouho zůstane nesouhlasný pár otočený, než ho server zakryje. */
export const MISMATCH_DELAY_MS = 2500;

// Pohled, který dostává klient.
export type CardView =
  | { state: "down" }
  | { state: "up"; animal: string }
  | { state: "matched"; animal: string; by: string };

export interface PexesoView {
  rows: number;
  cols: number;
  cards: CardView[];
  players: { id: string; name: string; score: number }[];
  turn: string;
  faceUp: number[];
  pendingHide: boolean;
  over: boolean;
  winners: string[];
}

export type PexesoAction = { type: "flip"; index: number } | { type: "hide" };
